module.exports = __webpack_public_path__ + "img/banner6.76c50f2c.jpg";